import axios from "axios";

export const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

adminApi.interceptors.response.use(undefined, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
    cfg._retry = true;
    await adminApi.post("/auth/refresh");
    return adminApi(cfg);
  }
  throw err;
});

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Não foi possível conectar. Tente novamente.";
};

export const ACTIONS = {
  subscribe: { label: "Assinaram", color: "#D4FF3A" },
  decline: { label: "Recusaram", color: "#FF7A7A" },
  support: { label: "Suporte", color: "#7FD8FF" },
  reconsider: { label: "Mudaram de ideia", color: "#FFC857" },
  view: { label: "Visitas", color: "#9DB0A5" },
};
